import "./Shapes.css";

const Shapes = () => {
    return (
        <div className="shapes">
            <svg viewBox="0 0 220 220" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                    d="M96.587 170.018C95.9376 175.502 91.5229 180 86 180L50 180C44.4772 180 39.9629 175.508 40.3517 169.999C45.2467 100.65 100.65 45.2467 169.999 40.3517C175.508 39.9629 180 44.4772 180 50V86C180 91.5229 175.502 95.9376 170.018 96.587C131.605 101.135 101.135 131.605 96.587 170.018Z"
                    fill="rgb(0, 0, 0)">
                </path>
            </svg>
            <svg viewBox="0 0 220 220" fill="none">
                <path
                    d="M60 110C60 145.277 86.0956 176.957 120.036 182.231C125.493 183.079 130 178.523 130 173V53C130 47.4772 125.501 42.9296 120.024 43.6404C86.0893 48.0449 60 74.727 60 110Z"
                    fill="rgb(213, 189, 175)">
                </path>
            </svg>
            <svg viewBox="0 0 220 220" fill="none">
                <path
                    d="M40 107C40 142.277 66.0956 173.957 100.036 179.231C105.493 180.079 110 175.523 110 170V50C110 44.4772 105.501 39.9296 100.024 40.6404C66.0893 45.0449 40 71.727 40 107Z"
                    fill="rgb(0, 0, 0)">
                </path>
                <circle cx="110" cy="110" r="66" stroke="rgb(0, 0, 0)" strokeWidth="8"></circle>
            </svg>
            <svg viewBox="0 0 220 220" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                    d="M96.587 170.018C95.9376 175.502 91.5229 180 86 180L50 180C44.4772 180 39.9629 175.508 40.3517 169.999C45.2467 100.65 100.65 45.2467 169.999 40.3517C175.508 39.9629 180 44.4772 180 50V86C180 91.5229 175.502 95.9376 170.018 96.587C131.605 101.135 101.135 131.605 96.587 170.018Z"
                    fill="rgb(213, 189, 175)"></path>
            </svg>
            <svg viewBox="0 0 220 220" fill="none">
                <path
                    d="M105 42.8867C108.094 41.1004 111.906 41.1004 115 42.8868L165.622 72.1133C168.716 73.8996 170.622 77.2008 170.622 80.7735V139.227C170.622 142.799 168.716 146.1 165.622 147.887L115 177.113C111.906 178.9 108.094 178.9 105 177.113L54.3782 147.887C51.2842 146.1 49.3782 142.799 49.3782 139.226V80.7735C49.3782 77.2008 51.2842 73.8996 54.3782 72.1132L105 42.8867Z"
                    fill="rgb(0, 0, 0)"></path>
            </svg>
            <svg viewBox="0 0 220 220" fill="none">
                <rect x="70" y="40" width="80" height="140" rx="40" fill="rgb(213, 189, 175)"></rect>
            </svg>
        </div>
    );
}

export default Shapes;